module.exports = __webpack_public_path__ + "static/media/home-1.48ddd489.png";